"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.packCardsNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
const extractProductChannels = (children, channelsOrder) => {
    var _a;
    const result = {};
    if (Object.keys(children).length === 0) {
        return null;
    }
    for (const key in children) {
        if (children.hasOwnProperty(key)) {
            const { categories, data } = children[key];
            const categorie = categories[0] || null;
            const icono = ((_a = data.fields) === null || _a === void 0 ? void 0 : _a.icono) || null;
            result[key] = {
                categorie,
                image: {
                    src: icono,
                    width: 143,
                    height: 99,
                },
            };
        }
    }
    if (channelsOrder.length > 1) {
        const orderedResult = {};
        channelsOrder.forEach((channel) => {
            orderedResult[channel] = result[channel];
        });
        return orderedResult;
    }
    return result;
};
const extractProductInfoItem = (product) => {
    if (!product) {
        return null;
    }
    const res = {};
    const { data, children } = product;
    if (data) {
        const { fields } = data;
        let productoGPBAF = null;
        productoGPBAF = fields === null || fields === void 0 ? void 0 : fields["DATAMAP_TV"];
        if (productoGPBAF) {
            const { fields } = productoGPBAF;
            if (children) {
                res.channels = extractProductChannels(children, fields === null || fields === void 0 ? void 0 : fields.channelsOrder);
            }
        }
    }
    return res;
};
const extractProductInfo = (product) => {
    if (Array.isArray(product)) {
        return product.map((productItem) => extractProductInfoItem(productItem));
    }
};
const normalizeOrionStructure = (products) => {
    if (Array.isArray(products)) {
        let productsObj = {};
        products.forEach((product, i) => {
            let channelsInfo = product.channels;
            productsObj[`Channels-${i + 1}`] = channelsInfo ? channelsInfo : null;
        });
        return productsObj;
    }
};
/**
 * normalizador del modulo MODULO_BUYBOX
 * @param {object} fields
 * @returns
 */
const packCardsNormalizer = (data) => {
    var _a, _b;
    try {
        let res = {};
        const sectionTitle = { text: (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title };
        const products = extractProductInfo((_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.products);
        if (products) {
            res = normalizeOrionStructure(products);
            if (sectionTitle && sectionTitle.text) {
                res["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), sectionTitle);
            }
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.packCardsNormalizer = packCardsNormalizer;
exports.default = exports.packCardsNormalizer;
//# sourceMappingURL=index.js.map